// extracted by mini-css-extract-plugin
export default {"front":"H4Kltr8kuHXuMpD6qCaC","frontStrocked":"WzVTR6A_QOecD60FI9Z0","back":"ZUenid3h581FKRwGkTZe","placeHolderShimmer":"RUnH_BETLrkWGURxKFnW"};